import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditMetricsCard = ({ title, value, icon, trend, trendType, loading }) => {
  const getTrendColor = () => {
    if (trendType === 'positive') return 'text-success';
    if (trendType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (trendType === 'positive') return 'TrendingUp';
    if (trendType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm animate-pulse">
        <div className="h-4 bg-muted rounded w-1/2 mb-3"></div>
        <div className="h-8 bg-muted rounded w-3/4 mb-2"></div>
        <div className="h-3 bg-muted rounded w-1/3"></div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <p className="text-xs md:text-sm text-muted-foreground font-medium">{title}</p>
        </div>
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
      </div>
      <div className="space-y-1">
        <h3 className="text-2xl md:text-3xl font-bold text-foreground">{value}</h3>
        {trend && (
          <div className="flex items-center gap-1">
            <Icon name={getTrendIcon()} size={14} className={getTrendColor()} />
            <span className={`text-xs md:text-sm font-medium ${getTrendColor()}`}>
              {trend}
            </span>
            <span className="text-xs text-muted-foreground">vs last period</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditMetricsCard;